import { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { TokenManager } from "../utils/tokenManager";
import { STORAGE_KEYS } from "./index";

export interface ApiErrorResponse {
  message: string;
  statusCode: number;
  error?: string;
  timestamp?: string;
  path?: string;
}

export const setupInterceptors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenManager.getBearerToken();

      if (token && config.headers) {
        config.headers.Authorization = token;
      }

      return config;
    },
    (error) => {
      console.error("Request interceptor error:", error);
      return Promise.reject(error instanceof Error ? error : new Error("Request failed"));
    }
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (error: AxiosError) => {
      if (error.response?.status === 401) {
        console.warn("Token inválido ou expirado. Redirecionando para login...");

        // Limpar todos os dados de autenticação
        TokenManager.clearToken();
        localStorage.removeItem(STORAGE_KEYS.AUTH_USER);
        localStorage.removeItem("authUser");
        localStorage.removeItem("davData");
        localStorage.removeItem("token");

        // Redirecionar para login
        globalThis.location.href = "/login";
        throw new Error("Token inválido");
      }

      if (process.env.NODE_ENV === "development") {
        console.error(`❌ API Error: ${error.response?.status} ${error.config?.url}`, error);
      }

      const errorData = error.response?.data as Record<string, unknown>;

      const apiError: ApiErrorResponse = {
        message: (errorData?.message as string) || error.message || "Erro desconhecido",
        statusCode: error.response?.status || 0,
        error: errorData?.error as string,
        timestamp: errorData?.timestamp as string,
        path: errorData?.path as string,
      };

      throw new Error(JSON.stringify(apiError));
    }
  );
};
